export default "__VITE_ASSET__KB1CfZjh__"